import { render, staticRenderFns } from "./reviewUnblock.vue?vue&type=template&id=4ff26b9c&"
import script from "./reviewUnblock.vue?vue&type=script&lang=js&"
export * from "./reviewUnblock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports